export type ChangelogEntry = {
  id: string
  publishedAt: string // ISO
  title?: string
  items: string[]
}
export const CHANGELOG_TTL_MS = 7 * 24 * 60 * 60 * 1000

export const CHANGELOG: ChangelogEntry[] = [
  {
    id: '14',
    publishedAt: '2026-05-05',
    title: 'Pacjenci -> Karta pacjenta (podgląd)',
    items: ['Dodano opcję wprowadzania pomiarów i obwodów ciała']
  },
  {
    id: '13',
    publishedAt: '2026-04-23',
    title: 'Aplikacja -> Kody przypisujące',
    items: ['Dodano możliwość filtrowania listy pacjentów po frazie.']
  },
  {
    id: '12',
    publishedAt: '2026-04-20',
    title: 'Zamówienia - udostępnianie diety w aplikacji',
    items: [
      'Dodano opcję wyboru między całym folderem a wybraną dietą. Przy wyborze konkretnej diety dodaliśmy podgląd posiłków w diecie.'
    ]
  },
  {
    id: '11',
    publishedAt: '2026-04-10',
    title: 'Menu -> Baza diet',
    items: [
      'Dodano podgląd Globalnej bazy diet oraz możliwość tworzenia Własnej bazy na podstawie bazowych diet przesłanych z PD3'
    ]
  },
  {
    id: '10',
    publishedAt: '2026-03-17',
    title: 'Pacjenci -> Karta pacjenta (podgląd)',
    items: ['Dodano podgląd na pomiary pacjenta']
  },
  {
    id: '9',
    publishedAt: '2026-03-13',
    title: 'Aplikacja -> Kody przypisujące',
    items: [
      'Dla użytkowników z dostępem do ankiet dodano możliwość generowania raportów'
    ]
  },
  {
    id: '8',
    publishedAt: '2026-03-04',
    title: 'Pacjenci -> Karta pacjenta (podgląd)',
    items: [
      'Dodano możliwość tworzenia bezpłatnych diet dla pacjenta',
      'Dodano podgląd na wypełnione ankiety pacjenta'
    ]
  },
  {
    id: '7',
    publishedAt: '2026-03-04',
    title: 'Menu - Pacjenci',
    items: [
      'Dodano listę pacjentów -> karta pacjenta ze szczegółowymi danymi (podgląd)'
    ]
  },
  {
    id: '6',
    publishedAt: '2026-02-18',
    title: 'Aplikacja -> Kody przypisujące',
    items: ['Dodano listę profili pacjentów przypisanych do kodu']
  },
  {
    id: '5',
    publishedAt: '2026-02-17',
    title: 'Aplikacja -> Kody przypisujące',
    items: ['Dla użytkowników z dostępem do ankiet - Dodano listę ankiet']
  },
  {
    id: '4',
    publishedAt: '2026-01-29',
    title: 'Aplikacja -> Kody przypisujące',
    items: ['Zaktualizowano instrukcję do druku z kodem QR']
  },
  {
    id: '3',
    publishedAt: '2026-01-27',
    title: 'Zamówienia',
    items: ['Na stronie ze szczegółami zamówienia dodano historię pacjenta.']
  },
  {
    id: '2',
    publishedAt: '2026-01-26',
    title: 'Zamówienia',
    items: [
      'Usunięto nieużywane statusy zamówienia: "Nie zapłacono" i "Anulowano"',
      'Naprawa drobnych błędów UI'
    ]
  },
  {
    id: '1',
    publishedAt: '2026-01-19',
    title: 'Stabilizacja',
    items: ['Poprawki wydajności']
  }
]
